import axios from 'axios'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {  useSelector } from "react-redux";
import { bulkrecentitemremove } from '../../Localstorage/Store';

const BulkRecentlyowl = ({elementid,pid,catid,catpage,titename,onMouseEnter,colorState,onMouseLeave}) => {
  const { bgColor, textColor } = useSelector((state) => state.theam);
  const [activecls,setactivecls] = useState("")


  const [Data,setData] = useState({})
const nvg = useNavigate()
  const transfer = (productid)=>{
    nvg("/productdetails",{ state: { id: productid,categoryid:catid,pagename:catpage,pname:Data[0].title} });
    window.location.reload();
  }

  useEffect(()=>{
     async function fetchcategory(){
      try {
      let url = `${process.env.REACT_APP_API_URL}homepageapi/GetProductDetailIdWise/${elementid}`;
      const response = await axios.get(url);
      if(response.data.data.length > 0){
        setData(response.data.data);
      }else{
        bulkrecentitemremove()
      }
    } catch (error) {
        // recentitemremove()
        console.log("this is is recently view")
    }
    }
    fetchcategory()
    
    },[])
  return (
    <div
    onMouseEnter={()=>{setactivecls(Data?.[0]?.id)}}
    onMouseLeave={()=>{setactivecls("")} }
      style={{ display:elementid == pid ? "none" : "block"}}
    >
      <div className=" mx-2 my-2 catbox">
    <div className="product-box p-0 " onClick={()=>{transfer(elementid)}}>
      <div className="product-imgbox" style={{position: "relative", overflow: "hidden" }}>
      {Data?.[0]?.stock_record?.num_in_stock <= 0 && (
        <div className="overlay" onClick={() => {transfer(Data?.[0]?.id, Data?.[0]?.title)}} >

                                            </div>)}

                                        {Data?.[0]?.stock_record?.num_in_stock <= 0 && (
                                          <div className="out-of-stock" style={{ backgroundColor: `#${bgColor}`}}
>Out of Stock</div>
                                        )}
        <div className="product-front" style={{ position: "relative",}}>
        {Data?.[0]?.stock_record?.discount != 0 && (
      <>

        <span
          style={{
            position: "absolute",
            width : "100px",

            fontSize: "12px",
            color: "#fff",
            backgroundColor: "#ff5722",
            padding: "2px 6px",
            borderRadius: "4px",
            fontWeight: "600",
          }}
        >
          
          {Data?.[0]?.stock_record?.discount === "amount"
            ? `₹${Data?.[0]?.stock_record?.discount} OFF`
            : `${Data?.[0]?.stock_record?.discount}% OFF`}
        </span>
      </>
    )}
        <button type='button' className='btn fixedhight' style={{width:'100%'}} onClick={()=>{transfer(elementid)}}>
            <img src={`${process.env.REACT_APP_API_URL}media/${Data[0]?.image[0]?.original}`} className="img-fluid  " alt="product" />
          </button>
          
        </div>
        
      </div>
      <div className="product-detail detail-inline ">
      {activecls === Data?.[0]?.id && (
    <span
      style={{
        position: "absolute",
        top: `${300 
          - (Data?.[0]?.title.length > 60 ? 20 : 0) 
          - (Data?.[0]?.title.length > 120 ? 20 : 0)}px`,
        left: "50%",
        transform: "translateX(-50%)", 
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        color: "#fff",
        fontSize: "10px",
        fontWeight: "400",
        textAlign: "center",
        borderRadius: "5px",
        padding: "6px 10px",
        zIndex: 9999,
        width: "max-content",
        maxWidth: "250px",
        whiteSpace: "normal",
        wordWrap: "break-word",
        opacity: 1,
        transition: "opacity 0.2s ease-in-out",
        boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
      }}
    >
      {`${Data?.[0]?.att_val.find(attr => attr.attribute__name.toLowerCase() === "brand")?.value_option__option || "N/A"}: ${Data?.[0]?.title}`}
    </span>
)}
   
         <div className="detail-title">
                                        <div className="detail-left" style={{width:'100%'}}>
                                          <div
                                            style={{display: "flex",flexDirection:'column',                        position: "relative", 

                                            }}
                                          >
                                            {" "}
                                            {/* <button
                                              type="button"
                                              className="btn"
                                              onClick={() => {
                                                transfer(item.id);
                                              }}
                                            > */}
                  <h6
  className="price-title catbox2"
  style={{
    // color: colorState.current && colorState.current[1] === Data?.[0]?.id ? "#808080" : "black",
    color: activecls === Data?.[0]?.id ? "#808080" : "black",
    fontSize: "14px",
    fontWeight: "100",
    height: "40px",
    lineHeight: "20px",
    display: "-webkit-box",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "normal",
    textAlign: "center",
    cursor: "pointer",
    position: "relative",
  }}
>
  <span style={{color:'green'}}>{`${Data?.[0]?.att_val.find(attr => attr.attribute__name.toLowerCase() === "brand")?.value_option__option || "N/A"}:`}</span>
  {`${Data?.[0]?.title}`}
  

</h6>


                                            {/* </button> */}
                                          </div>
                                        </div>
                                        <div
                                          className="detail-right"
                                          style={{ width: "100%" }}
                                        >
                                          <div
                                            className="price"
                                            style={{ width: "100%" }}
                                          >
                                            <div
                                              style={{
                                                display: "flex",
                                                justifyContent: "center",
                                                color: "#000",
                                                fontSize: "14px",
                                              }}
                                            >
                                              {" "}
                                              {/* ₹{item?.product?.[0]?.price} */}
                                              {/* ₹{Data?.[0]?.price} */}
                                             
                                             {new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 0, 
  maximumFractionDigits: 0, 
}).format(parseInt(Data?.[0]?.stock_record?.price))}
                                              {/* ₹{parseInt(Data?.[0]?.stock_record?.price)}{" "}  */}
                                              {Data?.[0]?.stock_record?.discount == 0 ? '' : <span style={{fontSize: '13px',color: '#c1c1c1',lineHeight: '20px',textDecoration: 'line-through',paddingLeft:'3px',fontWeight:'400'}}>
                                                {new Intl.NumberFormat("en-IN", {
  style: "currency",
  currency: "INR",
  minimumFractionDigits: 0, 
  maximumFractionDigits: 0, 
}).format(parseInt(Data?.[0]?.stock_record?.mrp))}
                                                {/* ₹{Data?.[0]?.stock_record?.mrp} */}
                                                </span>}{Data?.[0]?.stock_record?.discount == 0 ? '' : <span style={{fontSize: '12px',color: '#388e3c',lineHeight: '20px',paddingLeft:'3px',fontWeight:'400'}}></span>}

                                              {/* ₹{parseInt(Data?.[0]?.stock_record?.price)}{" "} {Data?.[0]?.stock_record?.discount == 0 ? '' : <span style={{fontSize: '13px',color: '#c1c1c1',lineHeight: '20px',textDecoration: 'line-through',paddingLeft:'3px',fontWeight:'400'}}>₹{Data?.[0]?.stock_record?.mrp}</span>}{Data?.[0]?.stock_record?.discount == 0 ? '' : <span style={{fontSize: '12px',color: '#388e3c',lineHeight: '20px',paddingLeft:'3px',fontWeight:'400'}}>{Data?.[0]?.stock_record?.discount_type == "amount" ? `(₹${Data?.[0]?.stock_record?.discount} off)` : `(${Data?.[0]?.stock_record?.discount} %off)`}</span>} */}

                                            </div>
                                            {/* <div className="price text-align-center" style={{display:'flex',justifyContent:'center'}}>  ₹{item.price} </div> */}
                                          </div>
                                        </div>
                                      </div>
      </div>
    </div>
    </div>
  </div>
  )
}

export default BulkRecentlyowl